import React from 'react';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function PricingSection() {
  const {
    isExpired
  } = useCountdown();
  return <div className="grain-section w-full px-6 py-32 md:py-40 bg-white" data-id="element-231">
      <div className="max-w-5xl mx-auto space-y-20" data-id="element-232">
        {/* Pricing Card */}
        <div className="relative" data-id="element-233">
          <div className="relative bg-white border border-teal-200 p-8 md:p-20 text-center space-y-10 shadow-2xl shadow-teal-100/50 rounded-[3rem]" data-id="element-234">
            {/* Top Accent */}
            <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-teal-400 to-teal-600 rounded-t-[3rem]" data-id="element-235"></div>

            <div className="space-y-4" data-id="element-236">
              <p className="text-sm text-teal-700 font-bold uppercase tracking-widest bg-teal-50 inline-block px-4 py-1.5 rounded-full border border-teal-100" data-id="element-237">
                {isExpired ? 'Standard Rate' : 'For a limited time'}
              </p>
              <h3 className="text-4xl md:text-6xl font-bold text-ink pt-4 tracking-tight" data-id="element-238">
                Meeting With the Master: <br data-id="element-239" />
                <span className="text-teal-600" data-id="element-240">ADVANCED</span>
              </h3>
              <p className="text-xl text-ink-light font-light" data-id="element-241">
                Delivered in a single, powerful 2–3 hour session
              </p>
            </div>

            <div className="py-8" data-id="element-242">
              {isExpired ? <div className="flex items-center justify-center" data-id="element-243">
                  <span className="text-6xl sm:text-8xl md:text-[10rem] font-black text-teal-600 tracking-tighter leading-none" data-id="element-244">
                    $5,000
                  </span>
                </div> : <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4" data-id="element-245">
                  <span className="text-3xl sm:text-4xl text-gray-400 line-through font-bold" data-id="element-246">
                    $5,000
                  </span>
                  <span className="text-6xl sm:text-8xl md:text-[10rem] font-black text-teal-600 tracking-tighter leading-none" data-id="element-247">
                    $1,500
                  </span>
                </div>}
              <p className="text-teal-600 font-bold mt-4" data-id="element-248">
                Only Limited Slots Available
              </p>
            </div>

            <p className="text-xl text-ink-light max-w-3xl mx-auto font-light leading-relaxed" data-id="element-249">
              If you're ready to stop messing around with guesswork, and you're
              ready to find out exactly what to do next for YOUR unique
              situation and your unique biology, this is your opportunity.
            </p>

            <div className="pt-8 space-y-8" data-id="element-250">
              <a href="https://go.peptidescienceinstitute.com/meeting-with-the-master-advanced" className="inline-flex items-center justify-center gap-3 w-full sm:w-auto px-8 sm:px-12 py-6 bg-gradient-to-r from-[#1d1d1f] to-[#2d2d2f] hover:from-black hover:to-[#1a1a1c] text-white text-xl sm:text-2xl font-bold rounded-full transition-all shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-251">
                Secure Your Slot Now
                <ArrowRightIcon className="w-6 h-6" data-id="element-252" />
              </a>

              <div className="flex flex-col md:flex-row justify-center gap-6 text-sm text-ink-light pt-4" data-id="element-253">
                <div className="flex items-center gap-2" data-id="element-254">
                  <ShieldCheckIcon className="w-5 h-5 text-teal-500" data-id="element-255" />
                  <span data-id="element-256">Pre-Session Fit</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-257">
                  <ShieldCheckIcon className="w-5 h-5 text-teal-500" data-id="element-258" />
                  <span data-id="element-259">End-of-Session Clarity</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}